import { gql } from '@apollo/client'

export const GET_CONTENT_STATS = gql`
  query GetContentStats($clientId: ID!, $startDate: String, $endDate: String) {
    contentStats(clientId: $clientId, startDate: $startDate, endDate: $endDate) {
      totalGenerated
      totalPublished
      totalPendingReview
      platformsConnected
      emailOutreach {
        generated
        pendingReview
        published
      }
      byPlatform {
        platform
        postCount
      }
    }
  }
`

export const GET_GBP_REVIEWS = gql`
  query GetGbpReviews($clientId: ID!, $locationId: String) {
    gbpReviews(clientId: $clientId, locationId: $locationId) {
      averageRating
      totalReviews
      ratingDistribution { rating count }
      recentReviews { authorName rating text replyStatus createdAt }
    }
  }
`

export const GET_KEYWORD_RANKINGS = gql`
  query GetKeywordRankings($clientId: ID!, $locationId: String, $keywords: [String!], $startDate: String, $endDate: String) {
    keywordRankings(clientId: $clientId, locationId: $locationId, keywords: $keywords, startDate: $startDate, endDate: $endDate) {
      keyword
      position
      positionChange
      clicks
      impressions
      ctr
    }
  }
`

export const GET_SITE_VISITS = gql`
  query GetSiteVisits($clientId: ID!, $locationId: String, $startDate: String, $endDate: String) {
    siteVisits(clientId: $clientId, locationId: $locationId, startDate: $startDate, endDate: $endDate) {
      totalSessions
      dailySessions { date sessions }
    }
  }
`

export const GET_GBP_LOCATIONS = gql`
  query GetGbpLocations($clientId: ID!) {
    gbpLocations(clientId: $clientId) {
      locationId
      locationName
    }
  }
`

export const SEARCH_GOOGLE_PLACES = gql`
  query SearchGooglePlaces($clientId: ID!, $query: String!) {
    searchGooglePlaces(clientId: $clientId, query: $query) {
      placeId
      name
      address
      rating
      totalRatings
    }
  }
`

export const SET_CLIENT_PLACE_ID = gql`
  mutation SetClientPlaceId($clientId: ID!, $placeId: String!) {
    setClientPlaceId(clientId: $clientId, placeId: $placeId)
  }
`

export const GET_CLIENT_GBP_PLACE = gql`
  query GetClientGbpPlace($clientId: ID!) {
    clientGbpPlace(clientId: $clientId) {
      placeId
      name
      address
      rating
      totalRatings
    }
  }
`

export const REMOVE_CLIENT_PLACE_ID = gql`
  mutation RemoveClientPlaceId($clientId: ID!) {
    removeClientPlaceId(clientId: $clientId)
  }
`

export const GET_EMAIL_RESPONSE_STATS = gql`
  query GetEmailResponseStats($clientId: ID!, $startDate: String, $endDate: String) {
    emailResponseStats(clientId: $clientId, startDate: $startDate, endDate: $endDate) {
      totalSent
      totalReplied
      replyRate
      emailConnected
      byDay {
        date
        sent
        replied
      }
    }
  }
`

export const GET_POST_PERFORMANCE = gql`
  query GetPostPerformance($clientId: ID!, $startDate: String, $endDate: String) {
    postPerformance(clientId: $clientId, startDate: $startDate, endDate: $endDate) {
      platformsConnected
      byPlatform {
        platform
        likes
        comments
        shares
        impressions
      }
    }
  }
`

export const GET_DASHBOARD_INSIGHTS = gql`
  query GetDashboardInsights($clientId: ID!) {
    dashboardInsights(clientId: $clientId) {
      generatedAt
      summary { signal label detail }
      perWidget {
        siteVisits         { signal label detail }
        emailOutreach      { signal label detail }
        emailResponses     { signal label detail }
        socialPerformance  { signal label detail }
        gbpReviews         { signal label detail }
        keywordRankings    { signal label detail }
        contentOverview    { signal label detail }
      }
    }
  }
`

export const REFRESH_DASHBOARD_INSIGHTS = gql`
  mutation RefreshDashboardInsights($clientId: ID!) {
    refreshDashboardInsights(clientId: $clientId) {
      generatedAt
      summary { signal label detail }
      perWidget {
        siteVisits         { signal label detail }
        emailOutreach      { signal label detail }
        emailResponses     { signal label detail }
        socialPerformance  { signal label detail }
        gbpReviews         { signal label detail }
        keywordRankings    { signal label detail }
        contentOverview    { signal label detail }
      }
    }
  }
`
